import { Component, ViewEncapsulation, Input } from '@angular/core';

export interface ILabelWithIconData {
  text: string;
  iconCssClass: string;
}

@Component({
    selector: 'app-label-with-icon',
    templateUrl: 'label-with-icon.component.html',
    styleUrls: ['label-with-icon.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LabelWithIconComponent {
  @Input() data = {
    text : 'Test',
    iconCssClass : 'fa fa-clock-o',
  };
}
